import { giphyPink, giphyRed } from '@giphy/js-brand'
import React from 'react'
import styled from 'styled-components'
import CreationToolStatus from '../../../../types/status'
import SnakeLoader from '../../../snake-loader'

const ErrorBar = styled.div`
    background: linear-gradient(45deg, ${giphyRed}, ${giphyPink});
    height: 2px;
    width: 100%;
`

type Props = {
    status: CreationToolStatus
    isError: boolean
}

const CreationUploadItemStatusBar = ({ status, isError }: Props) => {
    if (status !== CreationToolStatus.Idle) {
        return <SnakeLoader />
    }

    if (isError) {
        return <ErrorBar />
    }

    return null
}

export default CreationUploadItemStatusBar
